const prefix = 'PROMO_CODES_ACTIONS_';
export const GET_PROMO_CODES = `${prefix}GET_PROMO_CODES`;
export const GET_PROMO_CODES_SUCCESS = `${prefix}GET_PROMO_CODES_SUCCESS`;
